import React from 'react';

import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import anchorme from "anchorme";

import './menucard.scss';
import moment from 'moment';

class MenuCard extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const menuList = (
      <div className="restaurants-menucard-component__menu-list">
        <p className="restaurants-menucard-component__menu-list-title">MENU</p>
        <ul className="restaurants-menucard-component__menu-list__black-text list-unstyled">
          {
            this.props.menu.map((menuItem, index) => {
              let linkifiedMenuItem = anchorme(menuItem, {
                                                            truncate: 24,
                                                            attributes: [
                                                            {
                                                              name:"target",
                                                              value:"_blank"
                                                            }]
                                                          });


              return (<li key={index} dangerouslySetInnerHTML={{__html: linkifiedMenuItem}}></li>);
            })
          }
        </ul>
      </div>
    );

    const linkifiedDescription = (this.props.description ? 
      anchorme(this.props.description, {
        truncate: 24,
        attributes: [
        {
          name:"target",
          value:"_blank"
        }]
      }) : '-');

    moment.locale(this.props.currentLanguage);
    let fromTime = moment(this.props.start, 'HH:mm');
    let toTime = moment(this.props.end, 'HH:mm');

    fromTime = fromTime.isValid() ? fromTime.format('LT') : '-';
    toTime = toTime.isValid() ? toTime.format('LT') : '-';

    return (
      <div className="restaurants-menucard-component">
        <div>
          <h4 className="restaurants-menucard-component__title">
            <img className="img-circle" width={50} height={50} src={this.props.image} alt={this.props.type} />
            &nbsp;&nbsp;
            <strong>{this.props.translate(`restaurants.menu_card.${this.props.type}`)}</strong>
          </h4>
        </div>

        <div className="restaurants-menucard-component__when-where">
           <p className="restaurants-menucard-component__when-where-title">{this.props.translate('restaurants.menu_card.from_to', {from: fromTime, to: toTime})}</p>
           <p className="restaurants-menucard-component__when-where__black-text" dangerouslySetInnerHTML={{__html: linkifiedDescription}}></p>
        </div>

        <br/>

        {this.props.menu.length > 0 ? menuList : null}

      </div>
    );
  }
}

MenuCard.displayName = 'PagesRestaurantsMenuCard';
MenuCard.propTypes = {};
MenuCard.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code
  }
};

export default connect(mapStateToProps)(MenuCard);



// WEBPACK FOOTER //
// ./components/pages/restaurants/MenuCard.js